import angular from 'angular';

module.exports = angular.module('admin.models.inspection_report', [
  require('common/services/resource'),
])
.factory('InspectionReport', function(odResource) {

  const Resource = odResource('/admin/inspection_reports/:id/:path', {
    id: '@id'
  }, {
    'get': { method: 'GET' },
    'query': { method: 'GET', isArray: true },
    'remove': { method: 'DELETE' },
    'delete': { method: 'DELETE' }
  });

  class InspectionReport extends Resource {
    constructor(data) {
      super(data);
    }

    get isQc() {
      return this.inspection_kind === 'quality_control';
    }

    get isQcOrSelfQc() {
      return this.isQc || this.isSelfQc;
    }

    get isSelfQc() {
      return this.inspection_kind === 'self_quality_control';
    }
  }

  return InspectionReport;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/admin/models/inspection_report.js
 **/